import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    title: 'Identifica',
    desc: 'Reconoce tus patrones nocturnos y los irritantes ocultos en tu rutina.'
  }, {
    num: '02',
    title: 'Ajusta',
    desc: 'Aplica cambios simples en tus cenas y en tu ventana de hidratación.'
  }, {
    num: '03',
    title: 'Ejecuta',
    desc: 'Utiliza la técnica de vaciado completo antes de ir a la cama.'
  }, {
    num: '04',
    title: 'Observa',
    desc: 'Usa el diario incluido para notar cómo tus noches se vuelven más tranquilas.'
  }];
  return <section className="bg-navy-900 py-20 md:py-28 relative text-cream-50" data-id="element-180">
      <div className="container mx-auto px-4" data-id="element-181">
        <div className="max-w-[1000px] mx-auto" data-id="element-182">
          <FadeIn data-id="element-183">
            <div className="text-center mb-16" data-id="element-184">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-185">
                Cómo se usa
              </h2>
              <p className="text-lg text-cream-100/70 max-w-2xl mx-auto" data-id="element-186">
                Un proceso de 4 pasos diseñado para ser implementado sin
                complicaciones.
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-187">
            {steps.map((step, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-188">
                <div className="bg-navy-950 rounded-2xl p-8 border border-navy-800 h-full relative overflow-hidden group hover:border-gold-500/30 transition-colors" data-id="element-189">
                  <div className="text-5xl font-heading font-bold text-navy-800 mb-6 group-hover:text-gold-500/10 transition-colors" data-id="element-190">
                    {step.num}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3 relative z-10" data-id="element-191">
                    {step.title}
                  </h3>
                  <p className="text-cream-100/70 text-sm leading-relaxed relative z-10" data-id="element-192">
                    {step.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}